import { PATH_CHANGED } from '../../actionTypes';

export const pathChanged = (path) => ({ type: PATH_CHANGED, path });
